import React, { useEffect, useState } from 'react';

import { TextareaWithConfirm } from 'shared-components';

import { ITravelStatus } from '../../../../../../types';
import { useTranslation } from "react-i18next";

interface IProps {
  setComplete: (status: boolean) => void;
  travelStatus: ITravelStatus;
  additionalAnswers: {
    setAnswers: (data: Omit<ITravelStatus, 'status'>) => void;
  };
  setIsEdited: () => void;
}
export const TravelCancelled = ({
  travelStatus,
  additionalAnswers: { setAnswers },
  setIsEdited,
  setComplete,
}: IProps) => {
    const { t } = useTranslation('dialogs');
  const [reason, setReason] = useState(travelStatus.travelCanceledReason);

  useEffect(() => {
    setComplete(true);
  }, [setComplete]);

  useEffect(() => {
    setAnswers({ travelCanceledReason: reason });
  }, [reason, setAnswers]);

  return (
    <>
      <TextareaWithConfirm
        value={reason}
        label={t('dialogs:noteToAppearOnStatusOptional')}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          setReason(event.currentTarget.value);
          setIsEdited();
        }}
      />
    </>
  );
};
